<template>
    <dash-board-layout :active="1" :title="true">
        <toster />
        <div class="homepage mb-80">
            <div class="container">
                <div class="row">
                    <div class="col-xl-8 col-lg-8">
                        <div class="card profile_chart">
                            <div class="card-header">
                                <div class="chart_current_data">
                                    <h3>254856 <span>USD</span></h3>
                                    <p class="text-success">
                                        125648 <span>USD (20%)</span>
                                    </p>
                                </div>
                                <div class="duration-option">
                                    <a
                                        id="all"
                                        class="c-pointer"
                                        @click="active = 'all'"
                                        :class="active === 'all' && 'active'"
                                        >ALL time</a
                                    >
                                    <a
                                        id="one_month"
                                        class="c-pointer"
                                        @click="active = '1m'"
                                        :class="active === '1m' && 'active'"
                                        >24 H</a
                                    >
                                    <a
                                        id="six_months"
                                        class="c-pointer"
                                        @click="active = '6m'"
                                        :class="active === '6m' && 'active'"
                                        >7D</a
                                    >
                                    <a
                                        id="one_year"
                                        class="c-pointer"
                                        @click="active = '1y'"
                                        :class="active === '1y' && 'active'"
                                        >14D</a
                                    >
                                    <a
                                        id="ytd"
                                        class="c-pointer"
                                        @click="active = 'ytm'"
                                        :class="active === 'ytm' && 'active'"
                                        >30D</a
                                    >
                                </div>
                            </div>
                            <div class="card-body pt-0">
                                <!-- <div id="balance_graph"></div> -->
                                <timeline-chart />
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4">
                        <div class="card balance-widget">
                            <div class="card-header pb-0 border-0">
                                <h4 class="card-title">Your Portfolio</h4>
                            </div>
                            <div class="card-body pt-0">
                                <div class="balance-widget">
                                    <div class="total-balance">
                                        <h3>$63411.00</h3>
                                        <h6>Total Balance</h6>
                                    </div>
                                    <ul class="list-unstyled">
                                        <li class="d-flex">
                                            <i class="cc BTC me-3"></i>
                                            <div class="flex-grow-1">
                                                <h5 class="m-0">Bitcoin</h5>
                                            </div>
                                            <div class="text-right">
                                                <h5>0.000242 BTC</h5>
                                                <span>0.125 USD</span>
                                            </div>
                                        </li>
                                        <li class="d-flex">
                                            <i class="cc LTC me-3"></i>
                                            <div class="flex-grow-1">
                                                <h5 class="m-0">Litecoin</h5>
                                            </div>
                                            <div class="text-right">
                                                <h5>0.000242 LTC</h5>
                                                <span>0.125 USD</span>
                                            </div>
                                        </li>
                                        <li class="d-flex">
                                            <i class="cc XRP me-3"></i>
                                            <div class="flex-grow-1">
                                                <h5 class="m-0">Ripple</h5>
                                            </div>
                                            <div class="text-right">
                                                <h5>0.000242 XRP</h5>
                                                <span>0.125 USD</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-9 col-lg-9">
                        <div class="card">
                            <div class="card-header border-0 pb-0">
                                <h4 class="card-title">Recent Activities</h4>
                                <a href="#">View More </a>
                            </div>
                            <div class="card-body">
                                <div class="transaction-table">
                                    <div class="table-responsive">
                                        <table
                                            class="table mb-0 table-responsive-sm"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span class="sold-thumb"
                                                            ><i
                                                                class="la la-arrow-down"
                                                            ></i
                                                        ></span>
                                                    </td>

                                                    <td>
                                                        <span
                                                            class="badge bg-danger"
                                                            >Sold</span
                                                        >
                                                    </td>
                                                    <td>
                                                        <i class="cc BTC"></i>
                                                        Bitcoin
                                                    </td>
                                                    <td>
                                                        Using - Bank *******5264
                                                    </td>
                                                    <td class="text-danger">
                                                        -0.000242 BTC
                                                    </td>
                                                    <td>-0.125 USD</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span class="buy-thumb"
                                                            ><i
                                                                class="la la-arrow-up"
                                                            ></i
                                                        ></span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="badge bg-success"
                                                            >Buy</span
                                                        >
                                                    </td>
                                                    <td>
                                                        <i class="cc LTC"></i>
                                                        Litecoin
                                                    </td>
                                                    <td>
                                                        Using - Card *******8475
                                                    </td>
                                                    <td class="text-success">
                                                        -0.000242 BTC
                                                    </td>
                                                    <td>-0.125 USD</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span class="sold-thumb"
                                                            ><i
                                                                class="la la-arrow-down"
                                                            ></i
                                                        ></span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="badge bg-danger"
                                                            >Sold</span
                                                        >
                                                    </td>
                                                    <td>
                                                        <i class="cc XRP"></i>
                                                        Ripple
                                                    </td>
                                                    <td>
                                                        Using - Card *******8475
                                                    </td>
                                                    <td class="text-danger">
                                                        -0.000242 BTC
                                                    </td>
                                                    <td>-0.125 USD</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span class="buy-thumb"
                                                            ><i
                                                                class="la la-arrow-up"
                                                            ></i
                                                        ></span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="badge bg-success"
                                                            >Buy</span
                                                        >
                                                    </td>
                                                    <td>
                                                        <i class="cc DASH"></i>
                                                        Dash
                                                    </td>
                                                    <td>
                                                        Using - Card *******2321
                                                    </td>
                                                    <td class="text-success">
                                                        -0.000242 BTC
                                                    </td>
                                                    <td>-0.125 USD</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span class="sold-thumb"
                                                            ><i
                                                                class="la la-arrow-down"
                                                            ></i
                                                        ></span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="badge bg-danger"
                                                            >Sold</span
                                                        >
                                                    </td>
                                                    <td>
                                                        <i class="cc BTC"></i>
                                                        Bitcoin
                                                    </td>
                                                    <td>
                                                        Using - Card *******2321
                                                    </td>
                                                    <td class="text-danger">
                                                        -0.000242 BTC
                                                    </td>
                                                    <td>-0.125 USD</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3">
                        <div class="card apps-download">
                            <div class="card-body">
                                <h4 class="card-title">Mobile app</h4>
                                <div class="apps-download-content">
                                    <h3>
                                        Get the best mobile app to exchange or
                                        buy crypto on the go:
                                    </h3>
                                    <div class="mt-4 text-center">
                                        <a
                                            href="#"
                                            class="btn btn-primary my-1 ms-2"
                                            ><img
                                                src="../../assets/images/android.svg"
                                                alt=""
                                        /></a>
                                        <a
                                            href="#"
                                            class="btn btn-success my-1 ms-2"
                                            ><img
                                                src="../../assets/images/apple.svg"
                                                alt=""
                                        /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </dash-board-layout>
</template>
<script>
// import BtcChart from "../../components/charts/BtcChart";
import TimelineChart from "../../components/charts/TimelineChart.vue";
import Toster from "../../components/Toster.vue";
// import WalletChart from "../../components/charts/WalletChart.vue";
// import CurrencyForm from "../../components/form/CurrencyForm";
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
export default {
    components: {
        DashBoardLayout,
        // BtcChart,
        TimelineChart,
        Toster,
        // WalletChart,
        // CurrencyForm,
    },
    data() {
        return {
            active: "all",
        };
    },
};
</script>
